import { z } from 'zod';

import { CourseTestWritableShape } from '../test-create/test-create';

/**
 * Editing a test (`courses.manage`). Partial, so one locale tab can save alone.
 *
 * **`courseId` is deliberately absent**, so a test can never change hands: every
 * `course_completion` rule that names its course, and matrix row 3's distinction
 * between finishing a course and passing its test, are both anchored to a
 * relationship that must not move under attempts already taken.
 */
export const CourseTestUpdateSchema = z.object(CourseTestWritableShape).partial().strict();

export type CourseTestUpdateRequest = z.infer<typeof CourseTestUpdateSchema>;
